import { MatchConsultant } from "@src/api/match";
import { clsx, type ClassValue } from "clsx";
import crypto from "crypto";
import { twMerge } from "tailwind-merge";

export const hashStringData = (str: string) =>
	crypto.createHash("sha256").update(str).digest("hex");

export const getConsultantImage = (consultant: MatchConsultant | null) => {
	switch (consultant?.consultantRealName) {
		case "최준순": {
			return "/onepoint/images/consultant/choi.jpeg";
		}
		default: {
			return "/onepoint/images/consultant/default.png";
		}
	}
};

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
